// A Save's or a create's photos and videos as the lot's desired state holds them (BL-2815): each add
// names its staged file, and the files that cannot be sent from the phone are refused up front.
import { stagedFileIdOf, type OfflineAttachmentChanges, type OfflineMediaAdd } from '@auctogon/admin-isomorphic/isomorphic/offline/offline-attachments';
import type { MediaAdd, MediaSave } from '@auctogon/admin-isomorphic/isomorphic/offline/lot-state-media';

/** One add as the state keeps it: a staged file, or a file already in storage attached by its path. */
function mediaAddOf(item: OfflineMediaAdd): MediaAdd {
  const stagedFileId = stagedFileIdOf(item.storagePath);
  const stagedPosterFileId = stagedFileIdOf(item.posterStoragePath);
  return {
    id: item.id,
    type: item.type === 'video' ? 'video' : 'photo',
    ...(stagedFileId != null ? { stagedFileId } : item.storagePath ? { storagePath: item.storagePath } : {}),
    ...(stagedPosterFileId != null ? { stagedPosterFileId } : item.posterStoragePath ? { posterStoragePath: item.posterStoragePath } : {}),
    ...(item.caption ? { caption: item.caption } : {}),
    sortOrder: item.sortOrder,
    isCover: item.isCover,
  };
}

/**
 * @param changes - a Save's photo and video changes.
 * @param order - the photo ids in their new order, or null when the Save sent none.
 * @returns the media save for the lot's state, or null when an add has neither a staged file nor a stored path (refuse the Save).
 */
export function mediaSaveOf(changes: OfflineAttachmentChanges['media'], order: string[] | null): MediaSave | null {
  if (changes.add.some((item) => !item.storagePath)) return null;
  return { adds: changes.add.map(mediaAddOf), removes: changes.remove, order };
}

/**
 * @param save - a media save.
 * @returns true when it changes nothing.
 */
export function isMediaSaveEmpty(save: MediaSave): boolean {
  return save.adds.length === 0 && save.removes.length === 0 && save.order == null;
}
